
import React from "react";
import "./LegalPages.css";
import {
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  
  
} from 'react-icons/fa';


const TermsService = () => {
  return (
    <div className="terms_container">
      <h1>Terms of Service</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>Hiten Technologies</strong>. By accessing or using our
          website, software, and related services (collectively referred to as
          the “Services”), you agree to comply with and be bound by these Terms
          of Service. If you do not agree with these terms, please discontinue
          use of our Services.
        </p>
      </section>

      <section>
        <h2>2. Use of Services</h2>
        <p>
          You agree to use our Services responsibly, lawfully, and only for
          legitimate purposes. You must not attempt to damage, disrupt, or gain
          unauthorized access to our systems, servers, or networks.
        </p>
      </section>

      <section>
        <h2>3. User Accounts</h2>
        <p>
          Certain Services may require you to create an account. You are
          responsible for maintaining the confidentiality of your login details
          and for all activities under your account. You agree to notify us
          immediately of any unauthorized use or security breach.
        </p>
      </section>

      <section>
        <h2>4. Intellectual Property</h2>
        <p>
          All content, software, designs, and materials available through our
          Services are the property of <strong>HitenTechnologies</strong> or its
          licensors. They are protected under applicable Indian and
          international intellectual property laws. You may not copy, modify,
          reproduce, or distribute any material without prior written consent.
        </p>
      </section>

      <section>
        <h2>5. Privacy</h2>
        <p>
          Your use of our Services is also governed by our{" "}
          <a href="/privacy">Privacy Policy</a>. Please review it to understand
          how we collect, use, and protect your personal information in
          accordance with Indian data protection regulations.
        </p>
      </section>

      <section>
        <h2>6. Third-Party Services</h2>
        <p>
          Our Services may contain links or integrations with third-party
          websites or tools. We are not responsible for the content, privacy
          practices, or functionality of these third-party services. Use of such
          platforms is at your own risk.
        </p>
      </section>

      <section>
        <h2>7. Disclaimer of Warranties</h2>
        <p>
          Our Services are provided on an “as is” and “as available” basis
          without warranties of any kind, express or implied. We do not warrant
          that our Services will be uninterrupted, error-free, or free from
          security vulnerabilities.
        </p>
      </section>

      <section>
        <h2>8. Limitation of Liability</h2>
        <p>
          To the fullest extent permitted under applicable Indian law,{" "}
          <strong>Hiten Technologies</strong> and its affiliates shall not be liable
          for any indirect, incidental, consequential, or punitive damages
          arising from your use or inability to use our Services.
        </p>
      </section>

      <section>
        <h2>9. Changes to These Terms</h2>
        <p>
          We may update or revise these Terms of Service periodically. Any
          changes will be posted on this page. Continued use of our Services
          after such updates constitutes your acceptance of the revised Terms.
        </p>
      </section>

      <section>
        <h2>10. Governing Law and Jurisdiction</h2>
        <p>
          These Terms shall be governed by and construed in accordance with the
          laws of the <strong>Republic of India</strong>. Any disputes or claims
          arising out of or relating to these Terms shall be subject to the
          exclusive jurisdiction of the competent courts in{" "}
          <strong>India</strong>.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding these Terms of
          Service, please contact us:
        </p>
        <p>
          <FaEnvelope className="contact-icon" /><strong>Email:</strong> support@hitentechnologies.com <br />
          <FaPhone className="contact-icon" /><strong>Phone:</strong> +91 98904 13967 <br />
          <FaMapMarkerAlt className="contact-icon" /><strong>Address:</strong>  Flat No 304, B Wing, Rajveer Galaxy Sr No 3 Samarth Nagar Dighi, Pune, Maharashtra 411015
        </p>
      </section>
    </div>
  );
};

export default TermsService;
